<span mat-dialog-title class="font-title-contrast">{{data.title}}</span>
<mat-dialog-content>
    <span class="font-header-contrast">{{data.message}}</span>
    @if (data.question) {
        <br><br>
        <span class="font-header-contrast">{{data.question}}</span>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button  (click)="button_ok_clicked()"  cdkFocusInitial>OK</button>
    @if(data.showCancel) {
        <button mat-button (click)="button_cancel_clicked()">Abbrechen</button>
    }
</mat-dialog-actions>
